// Keep the displayed prices and submitted selling plan tied to the chosen variant.
const initialized = new WeakSet();
function initializeOptions() {
  document.querySelectorAll('[data-clean-purchase-labels] form').forEach((form) => {
    if (initialized.has(form)) return;
    initialized.add(form);
    const syncVariant = () => {
      const variantId = form.querySelector('[name="id"]').value;
      form.querySelectorAll('[data-purchase-variant]').forEach((fieldset) => {
        const active = fieldset.dataset.purchaseVariant === variantId;
        fieldset.hidden = !active;
        fieldset.disabled = !active;
        if (active && !fieldset.querySelector('input:checked')) {
          const first = fieldset.querySelector('input');
          if (first) first.checked = true;
        }
      });
    };
    form.querySelector('[name="id"]').addEventListener('change', syncVariant);
    syncVariant();
  });
}
initializeOptions();
document.addEventListener('shopify:section:load', initializeOptions);
